/* eslint-disable */
import React from "react";

export default function Ibutton() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 15.5C12.2541 15.5 15.5 12.2541 15.5 8.25C15.5 4.24594 12.2541 1 8.25 1C4.24594 1 1 4.24594 1 8.25C1 12.2541 4.24594 15.5 8.25 15.5Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.25 12.069V7.5"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.25 5.5C7.97447 5.5 7.75 5.27518 7.75 5C7.75 4.72482 7.97447 4.5 8.25 4.5C8.52553 4.5 8.75 4.72482 8.75 5C8.75 5.27518 8.52553 5.5 8.25 5.5Z"
        fill="#A0A0A0"
        stroke="white"
      />
    </svg>
  );
}
